import { LAYOUT_TYPES } from "utils/const";

export const createCookie = (name, value, days) => {
    var expires;
    if (days) {
        if (days < 0) {
            expires = "; expires=Thu, 01 Jan 1970 00:00:01 GMT;"
        } else {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
    }
    else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};

export const delete_cookie = (name) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

// Method to get the context of the login modal (single sign on or normal authentication)
export const getAuthenticationContext = () => {
    return window.location.pathname && window.location.pathname.includes(LAYOUT_TYPES.SSO) ? LAYOUT_TYPES.SSO : LAYOUT_TYPES.AUTH
}

export const checkIfContextIsSSO = () => {
    return window.location.pathname && window.location.pathname.includes(LAYOUT_TYPES.SSO);
}

export const getSSOLoginUrl = (token, redirectURL) => {
    return `/sso/login/${token}/${redirectURL}`;
}